import { expVal, expValEquals } from '@confluence/feature-experiments';

import type { Participant } from '../presenceTypes';
import { MAX_GROUP_SIZE } from '../presenceUtils';

export const useIsEligibleForSuggestions = (
	participants: Participant[],
	isLoggedIn: boolean,
	isGuest: boolean,
) => {
	if (!isLoggedIn || isGuest || participants.length >= MAX_GROUP_SIZE) {
		return false;
	}

	expVal('collab_in_team_presence_exp_aa', 'cohort', 'not-enrolled');
	if (expValEquals('collab_in_team_presence_exp', 'cohort', 'variation')) {
		return true;
	}
	return false;
};
